import { ApiError, isApiError } from './apiError'

export interface LogContext {
  source?: string
  tags?: Record<string, string | number | boolean | undefined>
  extra?: Record<string, unknown>
}

interface LogSink {
  captureError: (error: unknown, context?: LogContext) => void
  captureMessage: (message: string, context?: LogContext) => void
}

const consoleSink: LogSink = {
  captureError(error, context) {
    if (isApiError(error)) {
      const apiError = error as ApiError
      console.error('[logger:error]', {
        name: apiError.name,
        kind: apiError.kind,
        status: apiError.status,
        endpoint: apiError.endpoint,
        method: apiError.method,
        retryAfterMs: apiError.retryAfterMs,
        message: apiError.message,
        fieldErrors: apiError.fieldErrors,
        context,
      })
      return
    }
    console.error('[logger:error]', error, context)
  },
  captureMessage(message, context) {
    console.warn('[logger:message]', message, context)
  },
}

let activeSink: LogSink = consoleSink

export function setLogSink(sink: LogSink): void {
  activeSink = sink
}

export function logError(error: unknown, context?: LogContext): void {
  activeSink.captureError(error, context)
}

export function logMessage(message: string, context?: LogContext): void {
  activeSink.captureMessage(message, context)
}
